import { React, Fragment, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  CardBody,
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  CardFooter,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import {
  updateResumeHeadlineRequest,
  resetData,
} from "../../../redux/jobseeker/resume_headline/actions";

import { showToast } from "../../Common/Toast";
import { countWords } from "../../Common/CommonFunction";

const Resumeheadline = ({ profileData, validationMessages }) => {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    resume_headline: profileData.resume_headline || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: "" });
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const data = {
        resume_headline: formData.resume_headline,
      };
      dispatch(updateResumeHeadlineRequest(data));
    }
  };

  useEffect(() => {
    // Check if there are validation messages on page load
    if (validationMessages && validationMessages.length > 0) {
      const newErrors = {};
      validationMessages.forEach((msg) => {
        newErrors[msg.field] = msg.message;
      });
      setErrors(newErrors);
    }
  }, [validationMessages]);

  // validate form data

  const validate = () => {
    let errors = {};
    let isValid = true;

    // Check if the resume headline is provided
    if (!formData.resume_headline) {
      errors.resume_headline = "Resume headline is required";
      isValid = false;
    } else if (formData.resume_headline.length < 5) {
      // Check if the resume headline is at least 5 characters long
      errors.resume_headline = "Resume headline must be at least 5 characters long";
      isValid = false;
    } else if (formData.resume_headline.length > 250) {
      // Check if the resume headline exceeds 250 characters
      errors.resume_headline = "Resume headline cannot exceed 250 characters";
      isValid = false;
    } else if (/^\d+$/.test(formData.resume_headline)) {
      // Check if the resume headline contains only numbers
      errors.resume_headline = "Resume headline cannot be only numbers";
      isValid = false;
    } else if (/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(formData.resume_headline)) {
      // Check if the resume headline contains only special characters
      errors.resume_headline = "Resume headline cannot be only special characters";
      isValid = false;
    }
    setErrors(errors);
    return isValid;
  };

  useEffect(() => {
    // Check if there are validation messages on page load
    if (validationMessages && validationMessages.length > 0) {
      const newErrors = {};
      validationMessages.forEach((msg) => {
        newErrors[msg.field] = msg.message;
      });
      setErrors(newErrors);
    }
  }, [validationMessages]);

  const updateResumeReducerData = useSelector(
    (state) => state.updateResumeReducer
  );
  useEffect(() => {
    console.log("srd", updateResumeReducerData);
    if (
      updateResumeReducerData.status &&
      updateResumeReducerData.message != ""
    ) {
      showToast("success", updateResumeReducerData.message);
      dispatch(fetchJobseekerDataRequest());
      // props.toggleModal();
      dispatch(resetData());
    } else if (
      updateResumeReducerData.status == false &&
      updateResumeReducerData.message != ""
    ) {
      showToast("error", updateResumeReducerData.message);
      // props.toggleModal();
      dispatch(resetData());
    }
  }, [dispatch, updateResumeReducerData]);

  return (
    <Form className="theme-form" onSubmit={handleSubmit}>
      <CardHeader className="border-0">
        <h4> Edit Resume Headline</h4>
      </CardHeader>
      <CardBody className="pt-0">
        <FormGroup>
          <Label>
            Resume Headline
            <span className="text-danger">*</span>
          </Label>
          <Input
            type="textarea"
            className="form-control"
            rows={4}
            name="resume_headline"
            placeholder="Enter resume headline"
            onChange={handleInputChange}
            value={formData.resume_headline}
            maxLength={250}
          ></Input>
          <small className="text-muted">
            Words: {countWords(formData.resume_headline)}
          </small>
          {errors.resume_headline && (
            <small className="text-danger">{errors.resume_headline}</small>
          )}
        </FormGroup>
        <div className="d-flex justify-content-end">
          <Button
            disabled={updateResumeReducerData.isLoading}
            color="primary"
            type="submit"
          >
            Save
          </Button>
        </div>
      </CardBody>
    </Form>
  );
};

export default Resumeheadline;
